import makeUtcDate from "@/utils/date-utils/make-utc-date";
import {createFormatter, useFormatter} from "next-intl";
import formatDate from "@/utils/date-utils/format-date";

const formatListOfDates = (
  dates: string[],
  formatter: ReturnType<typeof useFormatter> | ReturnType<typeof createFormatter>,
  dayFormat: "2-digit" | "numeric" = "2-digit",
  monthFormat: "long" | "short" | "numeric" | "2-digit" | "narrow" = "2-digit",
  yearFormat: "numeric" | "2-digit" = "numeric"
): string[] => {
  if (!Array.isArray(dates)) return [];
  return dates.map((date) => {
    const utcDate = makeUtcDate(date);
    if (!utcDate) return "";
    return formatDate({
      utcDate,
      monthFormat,
      dayFormat,
      yearFormat,
      formatter
    });
  });
};

export default formatListOfDates;
